// Test IDs for the premium / payment feature.
export const PREMIUM = {
  ctaBanner: 'premium-cta-banner',
  ctaButton: 'premium-cta-button',
  navButton: 'premium-nav-button',
  subscribeButton: 'premium-subscribe-button',
  planPrice: 'premium-plan-price',
  trialBadge: 'premium-trial-badge',
  activeBadge: 'premium-active-badge',
  limitModal: 'premium-limit-modal',
  limitModalCta: 'premium-limit-modal-cta',
  successStatus: 'payment-success-status',
};
